import { render, staticRenderFns } from "./DashboardTotalJobs.vue?vue&type=template&id=73391221&scoped=true"
import script from "./DashboardTotalJobs.vue?vue&type=script&lang=js"
export * from "./DashboardTotalJobs.vue?vue&type=script&lang=js"
import style0 from "./DashboardTotalJobs.vue?vue&type=style&index=0&id=73391221&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73391221",
  null
  
)

export default component.exports